<script>
import publishingUpdatedTable from './publishing-updated.table'
import getExportedFilename from '@lib/utils/get-exported-filename'
export default {
  name: 'PublishingUpdatedTab',
  props: {
    publishing: {
      type: Object,
      required: true,
    },
    loading: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      table: publishingUpdatedTable(this),
    }
  },
  methods: {
    getExportedFilename() {
      return getExportedFilename(this.table.tableName)
    },
  },
}
</script>

<template>
  <table-layout
    :table-name="table.tableName"
    :processor="table.processor"
    :filters="table.filters"
    :columns="table.columns"
    :fragments="false"
    :export-filename="getExportedFilename"
    hider
  />
</template>
